export const PHONE_MIN_DIGITS = 8;
export const PHONE_MAX_DIGITS = 15;

const onlyDigits = (value = '') => value.replace(/\D/g, '');

export const normalizePhoneInput = (rawValue, { forcePlus = false } = {}) => {
    const asString = `${rawValue ?? ''}`.trim();
    const hasPlus = asString.startsWith('+') || forcePlus;
    const digits = onlyDigits(asString).slice(0, PHONE_MAX_DIGITS);

    if(!digits.length){
        return hasPlus ? '+' : '';
    }

    return hasPlus ? `+${digits}` : digits;
};

export const isValidPhone = (value, { requirePlus = false } = {}) => {
    if(!value) return false;

    const normalized = normalizePhoneInput(value, { forcePlus: requirePlus });
    const isGeneric = requirePlus ? /^\+\d{8,15}$/.test(normalized) : /^\+?\d{8,15}$/.test(normalized);
    if(!isGeneric) return false;

    if(normalized.startsWith('+1')){
        return /^\+1\d{10}$/.test(normalized);
    }

    return true;
};

// Ayuda bajo el teléfono de otro usuario (Usuarios, Superadmin): si ese número lo verificó por WhatsApp. Lo verifica el
// propio usuario en «Mi perfil»; sin teléfono queda la ayuda de siempre.
export const whatsappVerificationHelper = (phone, verifiedPhone) => {
    if (!phone) return undefined;
    return phone === verifiedPhone
        ? 'WhatsApp verificado por el usuario.'
        : 'WhatsApp sin verificar: el usuario lo verifica en «Mi perfil».';
};
